import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import type { CardProps } from './types'

import styles from './Card.module.scss'

/**
 * Базовая карточка продукта (правило 11): один цвет surface, без бордера,
 * разница блоков — тенью и внутренними тайлами, не цветом.
 */
export const Card = memo(function Card(props: CardProps) {
  const {
    padding = 'M',
    radius = 'CARD',
    theme = 'SURFACE',
    border = 'NONE',
    isGrow = false,
    isPressable = false,
    onPress,
    children,
  } = props

  const { pressProps, isPressed } = usePress({ onPress, isDisabled: !isPressable })

  return (
    <div
      className={cn(
        styles.root,
        styles[`padding_${padding}`],
        styles[`radius_${radius}`],
        styles[`theme_${theme}`],
        styles[`border_${border}`],
        isGrow && styles.isGrow,
        isPressable && styles.isPressable,
      )}
      role={isPressable ? 'button' : undefined}
      tabIndex={isPressable ? 0 : undefined}
      data-pressed={isPressable ? isPressed : undefined}
      {...(isPressable ? pressProps : {})}
    >
      {children}
    </div>
  )
})
